<template>
  <el-select
    class="select"
    v-model="userName"
    filterable
    remote
    :placeholder="placeholder"
    :remote-method="searchUser"
    @change="checkUserItem"
    clearable
    :loading="userLoading"
  >
    <el-option
      v-for="item in userOptions"
      :key="item.value"
      :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
import { getUserModelApi } from '@/api/user.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'allotUserSelect',
  props: {
    placeholder: {
      type: String,
      default: '请输入用户名',
    },
  },
  data() {
    return {
      userName: '',
      userOptions: [],
      userLoading: false,
    };
  },
  methods: {
    // 搜索用户
    async searchUser(val) {
      try {
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let res = await getUserModelApi({ userName: val, areaId });
        this.$nextTick(() => {
          this.userOptions = JSON.parse(
            JSON.stringify(res.data.dataList)
              .replace(/nickName/g, 'label')
              .replace(/userId/g, 'value')
          );
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkUserItem(val) {
      this.$emit('setUserId', val);
    },
  },
};
</script>

<style></style>
